import * as React from 'react';
import styles from './index.less';
// import FInput from '@/components/FInput';
import { Radio, Space } from 'antd';
import FVersionHandlerPopover from '@/components/FVersionHandlerPopover';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import {
  ConnectState,
  InformalNodeManagerPageModelState,
  // ReplaceInformExhibitState,
} from '@/models/connect';
import {
  ChangeAction,
  OnReplacerMountAction,
  OnReplacerOriginChangeAction,
  OnReplacerUnmountAction,
  FetchReplacerListAction,
  OnReplacerKeywordsChangeAction,
  OnReplacerListCheckedChangeAction,
  OnReplacerListVersionRangeChangeAction,
  OnReplacerBucketChangeAction,
} from '@/models/informalNodeManagerPage';
import * as AHooks from 'ahooks';
// import FDropdownMenu from '@/components/FDropdownMenu';
import FComponentsLib from '@freelog/components-lib';
import FIcons from '@/components/FIcons';
import FDropdown2 from '@/components/FDropdown2';
import FInput_Search from '@/components/FInput_Search';

interface ReplacerProps {
  dispatch: Dispatch;
  informalNodeManagerPage: InformalNodeManagerPageModelState;
}

interface ReplacerStates {
  searchInput: string;
}

const initStates: ReplacerStates = {
  searchInput: '',
};

function Replacer({ dispatch, informalNodeManagerPage }: ReplacerProps) {
  const [$state, $setState] = AHooks.useSetState<ReplacerStates>(initStates);

  // AHooks.useMount(() => {
  //   console.log('replacer**************');
  // });

  // React.useEffect(() => {
  //   // console.log('@#SDFGDFXVXCZVXZCVSfd');
  //   dispatch<FetchReplacerListAction>({
  //     type: 'replaceInformExhibit/fetchReplacerList',
  //   });
  // }, []);

  AHooks.useMount(() => {
    dispatch<OnReplacerMountAction>({
      type: 'informalNodeManagerPage/onReplacerMount',
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnReplacerUnmountAction>({
      type: 'informalNodeManagerPage/onReplacerUnmount',
    });
  });

  AHooks.useDebounceEffect(
    () => {
      dispatch<OnReplacerKeywordsChangeAction>({
        type: 'informalNodeManagerPage/onReplacerKeywordsChange',
        payload: {
          value: $state.searchInput,
        },
      });
    },
    [$state.searchInput],
    {
      wait: 300,
    },
  );

  async function onChange(value: Partial<InformalNodeManagerPageModelState>, loadData = false) {
    dispatch<ChangeAction>({
      type: 'informalNodeManagerPage/change',
      payload: {
        ...value,
      },
    });
    if (loadData) {
      await dispatch<FetchReplacerListAction>({
        type: 'informalNodeManagerPage/fetchReplacerList',
        payload: {
          restart: false,
          // origin: 'market',
        },
      });
    }
  }

  return (
    <>
      <div className={styles.replacerHeader}>
        {informalNodeManagerPage.replaceModal_Replacer_ResourceOptions.map((rr, ri) => {
          return (
            <React.Fragment key={rr.value}>
              {ri !== 0 && <div style={{ width: 20 }} />}
              <a
                className={
                  informalNodeManagerPage.replaceModal_Replacer_Origin === rr.value
                    ? styles.activated
                    : ''
                }
                onClick={() => {
                  dispatch<OnReplacerOriginChangeAction>({
                    type: 'informalNodeManagerPage/onReplacerOriginChange',
                    payload: {
                      value: rr.value,
                    },
                  });
                }}
              >
                {rr.title}
              </a>
            </React.Fragment>
          );
        })}
      </div>

      {informalNodeManagerPage.replaceModal_Replacer_Origin === 'object' && (
        <>
          <div style={{ height: 15 }} />
          <div style={{ padding: '0 15px' }}>
            {/* <FDropdownMenu
              options={informalNodeManagerPage.replaceModal_Replacer_BucketOptions}
              text={
                informalNodeManagerPage.replaceModal_Replacer_BucketOptions.find((b) => {
                  return b.value === informalNodeManagerPage.replaceModal_Replacer_Bucket;
                })?.text || ''
              }
              onChange={(value) => {
                dispatch<OnReplacerBucketChangeAction>({
                  type: 'informalNodeManagerPage/onReplacerBucketChange',
                  payload: {
                    value: value,
                  },
                });
              }}
            /> */}

            <FDropdown2
              autoArrow={true}
              // getPopupContainer={() => ref_Root.current as HTMLElement}
              menu={{
                // selectedKeys: [nodeManagerPage.exhibit_SelectedStatus],
                items: informalNodeManagerPage.replaceModal_Replacer_BucketOptions.map((rs) => {
                  return {
                    key: rs.value,
                    label: rs.text,
                  };
                }),
                onClick: (value) => {
                  dispatch<OnReplacerBucketChangeAction>({
                    type: 'informalNodeManagerPage/onReplacerBucketChange',
                    payload: {
                      value: value.key,
                    },
                  });
                },
              }}
            >
              <span>
                {informalNodeManagerPage.replaceModal_Replacer_BucketOptions.find((b) => {
                  return b.value === informalNodeManagerPage.replaceModal_Replacer_Bucket;
                })?.text || ''}
              </span>
            </FDropdown2>
          </div>
        </>
      )}

      {/*<FSelect*/}
      {/*  value={informalNodeManagerPage.replaceModal_Replacer_Origin}*/}
      {/*  dataSource={[*/}
      {/*    ...informalNodeManagerPage.replaceModal_Replacer_ResourceOptions,*/}
      {/*    ...informalNodeManagerPage.replaceModal_Replacer_BucketOptions,*/}
      {/*  ]}*/}
      {/*  onChange={(value: string) => {*/}
      {/*    // onChange({replacerOrigin: value}, true);*/}
      {/*    dispatch<OnReplacerOriginChangeAction>({*/}
      {/*      type: 'informalNodeManagerPage/onReplacerOriginChange',*/}
      {/*      payload: {*/}
      {/*        value: value,*/}
      {/*      },*/}
      {/*    });*/}
      {/*  }}*/}
      {/*/>*/}
      <div style={{ height: 15 }} />

      <div className={styles.replacerBody}>
        <div className={styles.replacerFilter}>
          {/* <FComponentsLib.FInput.FSearch */}
          <FInput_Search
            // theme='dark'
            className={styles.replacerFilterInput}
            // value={informalNodeManagerPage.replaceModal_Replacer_Keywords}
            value={$state.searchInput}
            // debounce={300}
            onChange={(e) => {
              // console.log(value, 'value!@#$');
              // onChange({replacerKeywords: value}, true);
              $setState({
                searchInput: e.target.value,
              });
            }}
            size={'small'}
          />
        </div>
        <div style={{ height: 15 }} />
        <Space size={10} direction='vertical' className={styles.replacerList}>
          {/*{console.log(informalNodeManagerPage.replaceModal_Replacer_ResourceList, 'replaceModal_Replacer_ResourceList0923jldsf')}*/}
          {informalNodeManagerPage.replaceModal_Replacer_ResourceList.map((rl) => {
            return (
              <div key={rl.id} className={styles.replacerListItem}>
                <Radio
                  disabled={rl.disabled}
                  // checked={rl.name === informalNodeManagerPage.replacerCheckedResourceName}
                  checked={rl.checked}
                  onClick={(e) => {
                    // onChange({replacerCheckedResourceName: rl.name})
                    dispatch<OnReplacerListCheckedChangeAction>({
                      type: 'informalNodeManagerPage/onReplacerListCheckedChange',
                      payload: {
                        id: rl.id,
                        // checked: true,
                      },
                    });
                  }}
                />
                <div className={styles.replacerListItemContent}>
                  <div>
                    <div>
                      <FComponentsLib.FContentText
                        text={rl.name}
                        type='highlight'
                        style={{ width: 270 }}
                        singleRow
                      />
                    </div>
                    <div style={{ height: 2 }} />
                    <div>
                      {rl.identity === 'resource' ? (
                        <FComponentsLib.FContentText
                          text={`${rl.type} | ${rl.latestVersion || '暂无版本'} | ${rl.updateTime}`}
                          type='additional2'
                        />
                      ) : (
                        <FComponentsLib.FContentText
                          text={`${rl.type || '未设置类型'} | ${rl.updateTime}`}
                          type='additional2'
                        />
                      )}

                      {rl.checked && rl.versions.length > 0 && (
                        <FVersionHandlerPopover
                          value={rl.versionRange}
                          versionOptions={rl.versions}
                          allowEmpty
                          onChange={(version) => {
                            dispatch<OnReplacerListVersionRangeChangeAction>({
                              type: 'informalNodeManagerPage/onReplacerListVersionRangeChange',
                              payload: {
                                id: rl.id,
                                versionRange: version,
                              },
                            });
                          }}
                        >
                          <FComponentsLib.FTextBtn type='default' style={{ fontSize: 12 }}>
                            {rl.versionRange || '最新版本'}
                            &nbsp;
                            <FIcons.FDown />
                          </FComponentsLib.FTextBtn>
                        </FVersionHandlerPopover>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Space>
      </div>
    </>
  );
}

export default connect(({ informalNodeManagerPage }: ConnectState) => ({
  informalNodeManagerPage,
}))(Replacer);
